
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.2 31.305c-1.9-4.8.1-11.8 6.3-11.8s8.2 6.8 6.3 11.7c-.1.4-.2.7-.4.8-1.6 2.9-3.4 5.7-5.6 8.1-.2.3-.5.3-.7 0-2.3-2.5-4.2-5.5-5.8-8.5 0-.05-.025-.1-.05-.15-.025-.05-.05-.1-.05-.15zm6.3 5.8c.8.1 4.7-6.7 5.2-7.7 3.8-8.8-14.1-8.8-10.3-.1.8 1.6 1.8 3.1 2.8 4.5.3.5 2.1 3.3 2.3 3.3z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.55 11.455c2.275.45 4.55.9 6.85 1.35.6.1.7 1.1.7 1.6v33.8c0 .3-.1 1.7-.7 1.6a440.44 440.44 0 01-4.59-.93c-2.52-.519-5.015-1.033-7.51-1.47-2.422-.404-4.714.105-7.086.632-.566.126-1.136.253-1.714.368-.646.121-1.272.255-1.886.386-2.425.516-4.66.993-7.214.514-3.9-.7-7.8-1.5-11.7-2.3-.6-.1-.7-1.1-.7-1.6v-33.8c0-.3.1-1.7.7-1.6 1.417.29 2.908.684 4.423 1.084 3.19.843 6.494 1.716 9.477 1.716 2.882-.065 5.98-.817 9.01-1.553 1.595-.388 3.172-.77 4.69-1.047 0-.1.1-.1.2-.1.062-.062.085-.047.118-.027.02.013.044.027.082.027 2.3.45 4.575.9 6.85 1.35zM27.787 45.573c.565-.126 1.135-.252 1.713-.368a64.934 64.934 0 002.011-.42c2.408-.53 4.675-1.03 7.189-.48 1.85.35 3.675.725 5.5 1.1 1.825.375 3.65.75 5.5 1.1v-30.7c-4.4-.8-8.8-1.7-13.2-2.6-1.525.277-3.134.699-4.769 1.127-3.082.807-6.256 1.638-9.131 1.573-3.03 0-6.257-.844-9.369-1.657-1.305-.341-2.59-.677-3.831-.943v30.7c1.585.292 3.17.619 4.749.944 2.204.455 4.395.906 6.551 1.256 2.422.404 4.714-.105 7.087-.632z"}})])
          )
        }
      }
    